import { forEachRegisteredCarouselController } from "../carousel-handles";
import { initializeSliderIntervalHandler } from "./interval-handler";

forEachRegisteredCarouselController(initializeSliderIntervalHandler);
